var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('quill-editor',{attrs:{"content":_vm.content[_vm.jkey],"disabled":_vm.disabled,"options":_vm.editorOptions},on:{"change":_vm.onEditor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }